import { ContractType } from '@ph-model/api';

export const calcContractTotal = (contracts: ContractType[]): number =>
  contracts.reduce((a: number, b: ContractType) => a + parseFloat(b.contractDealerCost), 0)
